import { type FormQueryParams } from '@core/queryParams';
import { type Theme } from '@core/theme';

export interface Catalog {
  themes: Theme[];
  isIpac: boolean;
  formQueryParams: FormQueryParams;
  tracking: Record<string, string>;
}

let state: Catalog | null = null;

export const initCatalog = (data: Catalog): void => {
  state = data;
};

export const catalog = (): Catalog => {
  if (state === null) {
    throw new Error('catalog read before init');
  }
  return state;
};
